import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './logo.png';
import nf404 from './404.png';

function NotFound () {
  return (
    <div className="page-content page-membership">
      <div className="nf-container">
        <div className="app-logo">
          <Link to="/">
            <img src={Logo} width="208" height="67" alt="4Case Solutions" />
          </Link>
        </div>
        <div className="nf-container-inside text-center">
          <h1 className="nf-header">
            Erro 404 <i className="fa fa-minus-circle text-danger" />
          </h1>

          <h2 className="nf-text">Página não encontrada...</h2>
          <img className="nf-img" src={nf404} alt="Desconectado" />
        </div>
        <p>
          <small className="copy-right">
            Copyright &copy;{`${new Date().getFullYear()} `}
            <a
              href="https://www.4case.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              4Case Solutions
            </a>
          </small>
        </p>
      </div>
    </div>
  );
}

export default NotFound;
